import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`GIPHY SDK for Android`}</h2>
    <h4>{`Requirements`}</h4>
    <ul>
      <li parentName="ul">{`AndroidX`}</li>
      <li parentName="ul">{`minSdkVersion 19`}</li>
    </ul>
    <p>{`Get started with the Android docs `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-android-sdk-ui-example/blob/master/Docs.md"
      }}>{`here`}</a></p>
    <h3>{`Installation`}</h3>
    <p>{`Add the GIPHY Maven repository to your project's `}<inlineCode parentName="p">{`build.gradle`}</inlineCode>{` file:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`maven {
  url "http://giphy.bintray.com/giphy-sdk"
}
`}</code></pre>
    <h4>{`Github Example Repo`}</h4>
    <p>{`Give the Android SDK `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-android-sdk-ui-example"
      }}>{`example app`}</a>{` a spin to see what it's all about.`}</p>
    <p>{`We also use Github for documentation, release notes, issue tracking, and more.`}</p>
    <ul>
      <li parentName="ul">{`Run the example app to see the GIPHY SDK in action with all of its configurations.`}</li>
      <li parentName="ul">{`View the `}<a parentName="li" {...{
          "href": "https://github.com/Giphy/giphy-android-sdk-ui-example/blob/master/Docs.md"
        }}>{`docs`}</a>{`.`}</li>
      <li parentName="ul">{`Open `}<a parentName="li" {...{
          "href": "https://github.com/Giphy/giphy-android-sdk-ui-example/issues"
        }}>{`issues or feature requests`}</a></li>
      <li parentName="ul">{`View `}<a parentName="li" {...{
          "href": "https://github.com/Giphy/giphy-android-sdk-ui-example/releases"
        }}>{`releases`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      